<script lang="ts">
	import { derived } from 'svelte/store';
	import { lerp } from '../../utils/lerp';
	import { percentElementHorzCentre, percentElementVertCentre } from '../../utils/element-position';
	import { urlFragment } from '../../stores/url-fragment';
	import Icon from './Icon.svelte';

	export let icon: string | null = null;
	export let id: string = '';
	export let title: string = '';

	const isSelected = derived( urlFragment, ( urlFragment ) => urlFragment.tab === id );
	let tab: HTMLDivElement;

	function show() {
		urlFragment.setUrlKey( 'tab', id );
	}

	function hide() {
		urlFragment.setUrlKey( 'tab', 'none' );
	}

	function fly( node, { duration } ) {
		return {
			duration,
			css: t => `
				left: ${ lerp( percentElementHorzCentre( tab ), 50, t ) }%;
				top: ${ lerp( percentElementVertCentre( tab ), 50, t ) }%;
				transform: translate( -50%, -50% ) scale( ${ lerp( 0.2, 1, t ) } );
			`,
		}
	}
</script>

<div bind:this={ tab } class="tab" class:selected={ $isSelected } on:click={ show }>
	{#if icon}
		<Icon i={ icon } />
	{/if}

	<span class="title">
		{title}
	</span>
</div>

{#if $isSelected }
	<div class="card" class:selected={ $isSelected } transition:fly={{duration: 100}}>
		<button class="close" on:click={ hide }>
			&#215;
		</button>

		<slot></slot>
	</div>
{/if}

<style>
	.tab, .card {
		background-color: #00315c;
		border: 3px solid #FFC300;
		border-radius: 20px;
		color: white;
	}

	.tab {
		display: inline-block;
		margin-left: 5px;
		user-select: none;
		cursor: pointer;
		box-shadow: h-offset v-offset blur spread;

		padding: 15px 20px 30px;
	}

	.title {
		margin-left: 10px;
	}

	.tab.selected {
		visibility: hidden;
	}

	.card {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate( -50%, -50% );
		z-index: 1000;
		box-shadow: 0 0 20px rgba( 0, 0, 0, 0.5 );

		padding: 20px;
	}

	.card :global( p ) {
		max-width: 40em;
	}

	.card:not( .selected ) {
		visibility: hidden;
	}

	.card :global( h1 ) {
		font-size: 30px;
		margin-top: 0px;
		margin-bottom: 10px;
	}

	button.close {
		position: absolute;
		right: 5px;
		top: 5px;

		background: none;
		border: none;
		box-shadow: none;
		font-size: 32px;
		color: #FFC300;
	}

	.card :global( h1 ) {
		display: inline-block;
		margin-right: 50px;
	}

	.card :global( hr ) {
		border: 1px solid #FFC300;
		background-color: #FFC300;
		margin: 20px -20px;
	}

	.card :global( button ) {
		margin: 10px;
	}
</style>
